export const handleApplySettingsFilters = (state, action) => {
  const { filters, filtersInitialState } = action.payload;
  const { languageFilter } = filters || {};

  if (languageFilter) {
    state.filters.languageFilter.selectedValue = languageFilter?.selectedValue;
    state.filters.languageFilter.hasFilter =
      languageFilter?.selectedValue !==
      filtersInitialState?.languageFilter.selectedValue;
  }
};
